import { Base } from '@core/base/base'
import { BaseClient } from '@core/base/http-client/base-client'
import { request } from '@core/base/http-client/methods'

export class BaseService extends Base {
    #http = BaseClient

    constructor(name: string) {
        super(name)
    }

    protected get request() {
        return request
    }

    get http() {
        return this.#http
    }
}
